module.exports = __webpack_public_path__ + "img/1_013.c08b1c80.jpg";